import { useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';

import { Button } from '../../../../components/buttons/Button';
import VisualizationContext from '../../../../contexts/VisualizationContext';
import { LayoutGestaoLeads } from './components/LayoutGestaoLeads';
import TablePerfis from './components/TablePerfis';

const PerfisLeads = () => {
  const { visualizationState, setVisualizationState } =
    useContext(VisualizationContext);
  useEffect(() => {
    setVisualizationState('gestao');
  }, []);
  return (
    <LayoutGestaoLeads>
      <div className="tw-bg-[#f4f4f4] tw-px-[16px]">
        <div className="tw-flex tw-flex-col md:tw-flex-row tw-gap-6 tw-mt-[1.875rem]">
          <div className="tw-bg-[#EBEBEB] md:tw-w-[50%] tw-h-[9.0625rem] md:tw-p-[1.88rem] md:tw-justify-start md:tw-items-start tw-justify-center tw-items-center tw-flex tw-flex-col tw-gap-5 tw-rounded-3xl">
            <p>Cadastre um novo gestor ou vendedor</p>

            <a
              href={`${process.env.REACT_APP_PORTAL_URL}/area-logada/#/acessos/gestao-usuarios`}
              target="_blank"
              rel="noreferrer"
            >
              <Button className="tw-bg-[#001E64] tw-w-[13.3125rem]">
                Criar novo usuário
              </Button>
            </a>
          </div>
          {/* <div className="tw-bg-[#EBEBEB] md:tw-w-[50%] tw-h-[9.0625rem] tw-p-[1.88rem]  md:tw-justify-start md:tw-items-start tw-justify-center tw-items-center tw-flex tw-flex-col tw-gap-5 tw-rounded-3xl">
            <p>
              Vincule um vendedor autônomo a sua corretora para receber leads
            </p>
            <Link to="cadastro">
              <Button className="tw-w-[13.3125rem] md:tw-w-[15.75rem]">
                Vincular novo vendedor
              </Button>
            </Link>
          </div> */}
        </div>

        <div className="tw-bg-white tw-shadow-sula tw-p-5 tw-rounded-3xl tw-mt-[1.875rem]">
          <TablePerfis rowsPerPage={5} />
        </div>
      </div>
    </LayoutGestaoLeads>
  );
};

export default PerfisLeads;
